<template>
  <div class="topics-wrapper">
    <TopicTitle />
    <TopicDeck class="flex-fill" />
  </div>
</template>

<script>
import TopicTitle from './TopicTitle';
import TopicDeck from './TopicDeck';

export default {
  name: 'Topics',
  components: {
    TopicTitle,
    TopicDeck
  }
};
</script>

<style scoped>
.topics-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  min-height: 100vh;
  padding-bottom: auto;
}
</style>
